export const notDefined = "NOT_DEFINED";
export const kompas = "KOMPAS";
export const easyCeiling = "EASY_CEILING";
export const odeon = "ODEON";
